import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

const ProfileCompletionBar = ({ user, children, storiesCount }) => {
  const { score, nextStep } = useMemo(() => {
    if (!user) return { score: 0, nextStep: null };

    let points = 0;
    if (user.name) points += 25;
    if (children && children.length > 0) points += 25;
    if (user.reminder?.enabled || user.reminder?.pushEnabled) points += 25;
    if (storiesCount > 0) points += 25;

    let step = null;
    if (!children || children.length === 0) {
      step = { label: 'Add your child\'s profile →', to: '/dashboard/children' };
    } else if (!user.reminder?.enabled && !user.reminder?.pushEnabled) {
      step = { label: 'Set a bedtime reminder →', to: '/dashboard/settings' };
    } else if (!storiesCount) {
      step = { label: 'Generate your first story →', to: '/dashboard/generate' };
    }

    return { score: points, nextStep: step };
  }, [user, children, storiesCount]);

  if (score >= 100) return null;

  return (
    <div
      className="rounded-4 p-3 mb-4"
      style={{
        background: 'var(--card-bg)',
        border: '1px solid var(--border-purple)',
      }}
    >
      <div
        className="fw-bold mb-2"
        style={{ fontSize: '14px', color: 'var(--text-main)' }}
      >
        Your family profile is {score}% complete
      </div>

      <div className="progress mb-3" style={{ height: '8px', background: 'var(--purple-section)' }}>
        <div
          className="progress-bar"
          role="progressbar"
          style={{
            width: `${score}%`,
            background: 'linear-gradient(90deg, #6f42c1, #9b59b6)',
            transition: 'width 0.5s ease',
          }}
          aria-valuenow={score}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>

      {nextStep && (
        <Link
          to={nextStep.to}
          style={{
            fontSize: '13px',
            color: 'var(--text-main)',
            textDecoration: 'none',
            fontWeight: 600,
          }}
        >
          {nextStep.label}
        </Link>
      )}
    </div>
  );
};

export default ProfileCompletionBar;
